import React, { Component } from 'react';
import PropTypes from 'prop-types';

import OutlinedTextField from '../textFields/OutlinedTextField';
import Wrapper from '../Wrapper';

import baseStyles from '../../../styles/baseStyles.module.scss';
import formStyles from '../styles/styles.module.scss';
import buttonStyles from '../buttons/styles/styles.module.scss';
import { validateUserForm, hasErrors } from '../../../utils/form_validaters/user_form_helper';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import FormButton from '../FormButton';
import { ProPageStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgotPasswordEmail: '',
      submitting: false,
      showErrorsOnType: false,
      errors: {
        forgotPasswordEmail: ''
      },
      serverError: null
    };
  }

  static TEXT = { ...ProPageStrings.forgotPasswordText, ...ProPageStrings.loginForm };
  static LOGIN_PAGE_URL = '/login';

  //validations

  failedFormValidation() {
    let validationErrors = { ...this.state.errors };
    let validation;
    for (let name in this.state.errors) {
      validation = validateUserForm(name, this.state[name], validationErrors);
      validationErrors = { ...validationErrors, ...validation.errors };
    }

    this.setState({ errors: validationErrors });
    return hasErrors(validationErrors);
  }

  // handlers

  handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    if (this.state.showErrorsOnType) {
      const errors = validateUserForm(name, value, { ...this.state.errors });
      this.setState({ ...errors, [name]: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSuccess = res => {
    window.location.href = LanguageSupportUtil.wrapUrlSafe(res.redirectUrl, this.props.locale);
  };

  handleError = res => {
    if (!res.responseJSON || !res.responseJSON.errors) {
      this.setState({ submitting: false });
      return;
    }

    this.setState({ serverError: res.responseJSON.errors.join(', '), submitting: false });
  };

  handleComplete = () => {};

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    if (this.failedFormValidation()) {
      this.setState({ showErrorsOnType: true });
      return;
    }

    this.setState({ submitting: true });
    let headers = this.props.locale ? { 'X-Language-Locale': this.props.locale } : {};
    const params = {
      [this.props.resourceName]: {
        login: this.state.forgotPasswordEmail
      }
    };

    ServerCommunicationUtil.postApiEndpoint(
      this.props.forgotPasswordUrl,
      params,
      this.handleSuccess,
      this.handleError,
      this.handleComplete,
      headers
    );
  };

  renderEmailInput() {
    return (
      <div className={formStyles.inputItem}>
        <OutlinedTextField
          name="forgotPasswordEmail"
          isError={this.state.errors.forgotPasswordEmail.length > 0}
          errorMessage={this.state.errors.forgotPasswordEmail}
          value={this.state.forgotPasswordEmail}
          label={ForgotPasswordForm.TEXT.email.title}
          changeHandler={this.handleChange}
          enterKeyHandler={this.handleSubmit}
          type="email"
        />
      </div>
    );
  }

  renderServerError() {
    return <div className={formStyles.serverError}>{this.state.serverError}</div>;
  }

  renderErrorsAndSubmit() {
    return (
      <div className={`${formStyles.inputItem}`}>
        {this.renderServerError()}
        <FormButton disabled={this.state.submitting} value={ForgotPasswordForm.TEXT.sendEmail} />
      </div>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.renderEmailInput()}
        {this.renderErrorsAndSubmit()}
      </form>
    );
  }

  render() {
    return (
      <Wrapper text={ForgotPasswordForm.TEXT} foot={<>{ForgotPasswordForm.TEXT.foot}</>} showStepText>
        <div className={baseStyles.section}>
          {this.renderForm()}
          <a className={`${buttonStyles.text}`} href={LanguageSupportUtil.wrapUrlSafe(ForgotPasswordForm.LOGIN_PAGE_URL, this.props.locale)}>
            {ForgotPasswordForm.TEXT.backSignIn}
          </a>
        </div>
      </Wrapper>
    );
  }
}

ForgotPasswordForm.propTypes = {
  locale: PropTypes.string,
  resourceName: PropTypes.string,
  forgotPasswordUrl: PropTypes.string
};

export default ForgotPasswordForm;
